<template>
  <div class="replaceCitrix">
    <Menu />
    <div class="replaceCitrix-top">
      <p class="replaceCitrix-top-desc1">
        思杰（Citrix）优选替代方案 <br />—— Desktron云桌面
      </p>
      <div class="replaceCitrix-top-desc2">
        高清流畅、极致性能、深度兼容信创
      </div>
      <a class="replaceCitrix-btn btn-common btn-primary" @click="handleClick"
        >申请试用</a
      >
      <div class="replaceCitrix-top-btns">
        <!-- <a class="btn-common">联系我们</a> -->
      </div>
    </div>
    <WhyDesktron />
    <Common :path="path" isReplace />
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import Common from "@/components/Desktron/Common";
import WhyDesktron from "@/components/Desktron/WhyDesktron.vue";

export default {
  components: {
    Menu,
    Footer,
    Common,
    WhyDesktron,
  },
  data() {
    return {
      path: "/desktron/replaceCitrix/contact",
    };
  },

  methods: {
    handleClick() {
      this.$router.push({
        path: this.path,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.btn-common {
  display: block;
  box-sizing: border-box;
  width: 256px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid rgba(105, 116, 167, 0.22);
  background: #fff;
  color: #0c89e4;
  text-align: center;
  line-height: 38px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #ecf6fd;
    border-color: #0c89e4;
  }

  &:active {
    background-color: #ecf6fd;
    border-color: #0c89e4;
  }
}

.btn-common + .btn-common {
  margin-left: 18px;
}

.btn-primary {
  background-color: #0c89e4;
  color: #ffffff;
  border-color: #0c89e4;

  &:hover {
    background-color: #2495e7;
    border-color: #2495e7;
  }

  &:active {
    background-color: #0b7bcd;
    border-color: #0b7bcd;
  }
}
.replaceCitrix-top {
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: #f5faff;

  text-align: center;
  color: #232729;

  .replaceCitrix-top-desc1 {
    font-size: 20px;
    line-height: 1.2;
    margin-top: 30px;
  }

  .replaceCitrix-top-desc2 {
    font-size: 16px;
    line-height: 1.2;
    margin-top: 15px;
  }

  .replaceCitrix-btn {
    margin-top: 22px;
  }

  .replaceCitrix-top-btns {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 321px;
    background: url("~@/assets/desktron/replaceCitrix/top.png") center no-repeat;
    background-size: 100% 100%;
  }
}
</style>
